import Vue from 'vue'
import Store from './store'
import Feedable from './feedable'

export default abstract class BaseEntity<T extends Store> extends Feedable {
    public get $database() {
        return Vue.prototype.$database as T
    }
}
